export class RetournerDossier
{
    requestId: String;
    recipient: String;
    motif: String;
}